module.exports = __webpack_public_path__ + "static/media/undraw_education.d424d1ad.svg";